export const isCopyPromiseEnabled = () => {
  try {
    new ClipboardItem({
      ['text/plain']: Promise.resolve(new Blob([''], { type: 'text/plain' })),
    });

    return true;
  } catch (e) {
    return false;
  }
};
